<template>
    <or-layout>
        <a-tabs default-active-key="teacher" @change="tabsChange">
            <a-tab-pane tab="教师排行" key="teacher">
                <a-row :gutter="[16,16]" type="flex" justify="space-between">
                <a-col :span="24">
                    <a-form layout="inline">
                        <a-form-item  >
                            <a-select
                                    v-model="create_campus"
                                    placeholder="选择校区"
                                    style="width: 120px;"
                            >
                                <a-select-option value="">全部</a-select-option>
                                <a-select-option value="6dfe924ebff9413a4704224aa2506cf1">老城校区</a-select-option>
                                <a-select-option value="9bb546edc49c137c37c6eac9f4d68c50">雪峰校区</a-select-option>
                                <a-select-option value="a67f4c4782a590374d933429544710e8">南河校区</a-select-option>
                                <a-select-option value="cbbfbd30bdc7ab91fc70a6d332fd7c8e">公园校区</a-select-option>
                                <a-select-option value="cd206a274a98895653b63b08254912b3">宝轮校区</a-select-option>
                                <a-select-option value="d0e2c68e48add05e87cb1ed516e450f4">东坝校区</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-range-picker @change="onDateChange" format="YYYY-MM-DD " :placeholder="['开始日期', '结束日期']" />
                        </a-form-item>
                        <a-form-item>
                            <a-button type="primary" htmlType="submit" icon="search" @click="searchbtn" />
                        </a-form-item>
                    </a-form>
                </a-col>
                </a-row>
                <a-divider></a-divider>
               <div style="width: 100%;overflow: scroll" v-if="data!=[]">
                    <v-chart  :forceFit="true" padding="auto" :loading="loading"  :scale="{dataKey:'cnt', alias:'数量'}" :height="300" :data="data">
                        <v-tooltip title="teacher_name" />
                        <v-axis dataKey="teacher_name" label="teacher_name" />
                        <v-axis dataKey="teacher_name" position="right" />
                        <v-bar position="teacher_name*cnt" />
                    </v-chart>
                </div>
                <a-table
                        :dataSource="data"
                        :rowKey="item => item.create_by"
                        :pagination="false"
                        :loading="loading"
                           size="small"
                        bordered
                >
                    <a-table-column key="campus_name" title="校区名字" data-index="campus_name"/>
                    <a-table-column key="cnt" title="数量" data-index="cnt"/>
                    <a-table-column key="teacher_name" title="教师名字" data-index="teacher_name"/>
                </a-table>
           </a-tab-pane>
            <a-tab-pane tab="校区排行" key="campus">
               <div style="width: 100%;overflow: scroll" >
                    <v-chart :forceFit="true" padding="auto" :scale="{dataKey:'cnt', alias:'数量'}" :height="300" :data="data">
                        <v-tooltip title="campus_name" />
                        <v-axis dataKey="campus_name" label="campus_name" />
                        <v-axis dataKey="campus_name" position="right" />
                        <v-bar position="campus_name*cnt" />
                    </v-chart>
                </div>
              <a-table
                        :dataSource="data"
                        :rowKey="item => item.create_campus"
                        :pagination="false"
                        :loading="loading"
                                size="small"
                        bordered
                >
                    <a-table-column key="campus_name" title="校区名字" data-index="campus_name"/>
                    <a-table-column key="cnt" title="数量" data-index="cnt"/>
                </a-table>
            </a-tab-pane>
            <a-tab-pane tab="年级分布" key="grade">
              <div style="width: 100%;overflow: scroll" v-if="tabsKey=='grade'" >
                    <v-chart :forceFit="true" padding="auto" :scale="{dataKey:'percent', formatter: '.0%', min: 0}" :height="300" :data="data">
                        <!-- <v-tooltip title="grade_name" />
                        <v-axis dataKey="grade_name" label="grade_name" />
                        <v-axis dataKey="grade_name" position="right" />
                        <v-bar position="grade_name*cnt" /> -->
                         <v-tooltip :showTitle="false" dataKey="grade_name*cnt" />
                      <v-legend dataKey="percent" />
                      <v-pie position="percent" color="grade_name" :v-style="pieStyle" :label="gradeLabelConfig" />
                      <v-coord type="theta" />
                    </v-chart>
                </div>
              <a-table
                        :dataSource="data"
                        :rowKey="item => item.grade_id"
                        :pagination="false"
                        :loading="loading"
                        size="small"
                        bordered
                >
                    <a-table-column key="grade_name" title="年级" data-index="grade_name"/>
                    <a-table-column key="cnt" title="数量" data-index="cnt"/>
                </a-table>
            </a-tab-pane>
            <a-tab-pane tab="学科分布" key="subject">
                <div v-if="tabsKey=='subject'" >
                    <v-chart :forceFit="true" padding="auto" :scale="{dataKey:'percent', formatter: '.0%', min: 0}" :height="300" :data="data">
                        <!-- <v-tooltip title="subject_name" />
                        <v-axis dataKey="subject_name" label="subject_name" />
                        <v-axis dataKey="subject_name" position="right" />
                        <v-bar position="subject_name*cnt" /> -->
                      <v-tooltip :showTitle="false" dataKey="subject_name*cnt" />
                      <v-legend dataKey="percent" />
                      <v-pie position="percent" color="subject_name" :v-style="pieStyle" :label="labelConfig" />
                      <v-coord type="theta" />
                    </v-chart>
                </div>
                 <a-table
                        :dataSource="data"
                        :rowKey="item =>'subject_'+item.subject_id"
                        :pagination="false"
                        :loading="loading"
                           size="small"
                        bordered
                >
                    <a-table-column key="subject_name" title="学科" data-index="subject_name"/>
                    <a-table-column key="cnt" title="数量" data-index="cnt"/>
                </a-table>
            </a-tab-pane>
            <a-tab-pane tab="生源学校" key="school">
              <div style="width: 100%;overflow: scroll" v-if="tabsKey=='school'">
                     <v-chart :forceFit="true" padding="auto"  :scale="{dataKey:'cnt',alias: '数量',}" :height="500" :data="data">
                       <v-legend dataKey="school_name" />
                        <v-tooltip title="school_name" />
                        <v-axis dataKey="school_name" :label="{rotate:50}" position="right" />
                        <v-bar position="school_name*cnt" />
                    </v-chart>
                </div>
              <a-table
                        :dataSource="data"
                        :rowKey="item =>'school_'+ item.id"
                        :pagination="false"
                        :loading="loading"
                        size="small"
                        bordered
                >
                    <a-table-column key="school_name" title="校区名字" data-index="school_name"/>
                    <a-table-column key="cnt" title="数量" data-index="cnt"/>
                </a-table>
                
            </a-tab-pane>
       </a-tabs>
    </or-layout>
</template>

<script>
  export default {
    name: 'g2Demo',
    data() {
      return {
        data:[],
        height: 300,
        loading:false,
        dataPath:"/api/Student/getNewStudentStatisticByTeacher",
          pieStyle: {
          stroke: "#fff",
          lineWidth: 1
        },
        start_time:"",
        end_time:"",
        create_campus:"",
        tabsKey:"teacher",
        labelConfig: ['percent', {
          formatter: (val, item) => {
            return item.point.subject_name + ' : ' + val;
          }
        }],
        gradeLabelConfig: ['percent', {
          formatter: (val, item) => {
            return item.point.grade_name + ' : ' + val;
          }
        }],
      };
    },
    mounted(){
      this.searchbtn();
    },
    methods:{
      onDateChange(res){
        this.start_time = parseInt(res[0].valueOf() / 1000);
        this.end_time = parseInt(res[1].valueOf() / 1000)
      },
      searchbtn(){
        this.getDataList({create_campus:this.create_campus,start_time:this.start_time,end_time:this.end_time})
      },
      getDataList(data ) {
       this.loading= true;
        this.$axios
          .post(this.dataPath, {
            data
          })
          .then(res => {
            this.loading = false;
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定"
              });
            } else {
              this.data = res.data;
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      tabsChange(key){
        this.data=[];
        this.tabsKey=key;
        if (key=='teacher') {
          this.dataPath="/api/Student/getNewStudentStatisticByTeacher";
        } else if(key=='campus') {
          this.dataPath="/api/Student/getNewStudentStatisticByCampus";
        }else if(key=='grade') {
          this.dataPath="/api/Student/getNewStudentStatisticByGrade";
        }else if(key=='subject') {
          this.dataPath="/api/Student/getNewStudentStatisticBySubject";
        }else if(key=='school') {
          this.dataPath="/api/Student/getNewStudentStatisticBySchool";
        }
        this.searchbtn();
      }
    }

  };
</script>
